"use client";

import { c as _c } from "react/compiler-runtime";
import { ClerkProvider as ClerkProviderOriginal } from "@clerk/nextjs";
import { dark } from "@clerk/themes";
import { useTheme } from "next-themes";
import { ReactNode, Suspense } from "react";
export default function ClerkProvider(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const {
    resolvedTheme
  } = useTheme();
  const t1 = resolvedTheme === "dark" ? dark : undefined;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      baseTheme: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== t2) {
    t3 = <Suspense><ClerkProviderOriginal appearance={t2}>{children}</ClerkProviderOriginal></Suspense>;
    $[2] = children;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}